import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const ESimModalBody = styled.div`
    display: flex;
    flex-wrap: nowrap;
    gap: ${getPurpurSpacing('400')};
    flex-direction: column;

    ${purpurMedia('md')`
        align-items: center;
        flex-direction: row;
    `}
`;

export const ESimModalImage = styled.img`
    flex-shrink: 0;
    width: 5.75rem;
    height: 5.75rem;
    object-fit: contain;

    ${purpurMedia('md')`
        width: 9.875rem;
        height: 9.875rem;
    `}
`;
